'use strict';

require('react');
var SymbolsCounter_style = require('./SymbolsCounter.style-64b0606b.js');
var react = require('@emotion/react');

var SymbolsCounter = function SymbolsCounter(_ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    maxLength = _ref.maxLength;
  var valueLength = Array.isArray(value) ? value.length : String(value).length;
  var maxLengthToDisplay = maxLength || '∞';
  var valueLengthToDisplay = String(valueLength);
  var counterMinWidth = String(maxLength).length * 2 + 1 + 'ch';
  return react.jsx(SymbolsCounter_style.SymbolsCounterStyled, {
    style: {
      minWidth: counterMinWidth
    }
  }, valueLengthToDisplay, "/", maxLengthToDisplay);
};

exports.SymbolsCounter = SymbolsCounter;
//# sourceMappingURL=SymbolsCounter-ac370612.js.map
